var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 110,
    viewBox: "0 0 109 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_619_4069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3711 7.50914L55.685 47.892L83.5294 47.9857L45.6281 102.731L53.3143 58.3031L25.4716 58.2061L63.3711 7.50914ZM63.3764 0.696746C63.1924 0.696746 63.0086 0.703452 62.8281 0.716971C61.6256 0.814155 60.8285 1.21609 59.8833 1.85136C59.3511 2.20618 58.8713 2.63385 58.4578 3.12189C58.3337 3.26836 58.2165 3.42068 58.1069 3.57833L19.9347 54.0981C18.4275 56.164 18.2061 58.8908 19.3642 61.1696C20.5206 63.4484 22.859 64.8926 25.4222 64.9114L45.0865 65.0544L38.9042 101.479C38.3166 104.61 39.9856 107.73 42.9235 108.987C43.7773 109.353 44.697 109.542 45.6263 109.542C47.7671 109.542 49.5264 108.54 50.8465 106.732L89.0663 51.9862C90.5736 49.9203 90.7934 47.1901 89.6368 44.9148C88.4804 42.636 86.142 41.1916 83.5788 41.173L63.9145 41.1389L70.0305 9.11167C70.1601 8.58733 70.2253 8.04915 70.2247 7.50903C70.2247 3.82347 67.2901 0.819158 63.6182 0.699939C63.5366 0.696533 63.4564 0.696533 63.3765 0.696533L63.3764 0.696746Z",
    fill: "#2B3674"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_619_4069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 109,
    fill: "white",
    transform: "translate(0 0.619995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.42b1fbcc532a7e508e66e734bb57219c.svg";
export { ForwardRef as ReactComponent };